<template>
    <div>
        <!-- thumbnails -->
        <div v-for="(image, index) in filteredImages"
             :class="customImageClass"
             class="lightbox-thumbnail-wrapper"
             @click="open(index)">
            <img class="lightbox-thumbnail" :src="image[thumbnailSrc].substring(0, 4) === 'data' ? image[thumbnailSrc] : image[thumbnailSrc] + compress">
        </div>

        <!-- lightbox -->
        <div v-if="boxOpen" class="lightbox">
            <i class="far fa-times close-lightbox hover" @click="close"></i>
            <div class="lightbox-image">
                <img v-click-outside="close" :src="openImage[src]">
            </div>
        </div>
    </div>
</template>

<script>
    import vClickOutside from 'v-click-outside'

    export default {
        name: 'LightBox',

        data() {
            return {
                boxOpen: false,
                openImage: false,
                openIndex: false,
            }
        },

        props: {
            images: {
                type: Array,
                default: [],
                required: true
            },
            customImageClass: {
                type: String,
                default: false
            },
            thumbnailSrc: {
                required: true
            },
            src: {
                required: true
            },
            compressThumbnail: {
                default: true
            }
        },

        computed: {
            compress() {
                return this.compressThumbnail ? '?width=320' : '';
            },

            filteredImages() {
                return this.images.filter(image => this.isImage(image) && image[this.thumbnailSrc]);
            },
        },

        methods: {
            open(index) {
                this.openImage = this.filteredImages[index];
                this.boxOpen = true;
                this.openIndex = index;

                this.setListeners();
            },

            close() {
                if(this.boxOpen) {
                    this.openImage = false;
                    this.boxOpen = false;
                    this.openIndex = false;
                }
            },

            navigate(direction) {
                let newIndex = this.openIndex+1;

                if(direction === 'left') {
                    newIndex = newIndex-1;

                    if(newIndex > 0) {
                        this.openImage = this.filteredImages[newIndex-1];
                        this.openIndex = newIndex-1;
                    }
                } else {
                    newIndex = newIndex+1;

                    if(newIndex <= this.filteredImages.length) {
                        this.openImage = this.filteredImages[newIndex-1];
                        this.openIndex = newIndex-1;
                    }
                }
            },

            setListeners() {
                const keyHandler = (e) => {
                    if (e.key === `Escape`) {
                        this.close();
                    } else if (e.key === `ArrowLeft`) {
                        this.navigate('left');
                    } else if (e.key === `ArrowRight`) {
                        this.navigate('right');
                    }
                };

                document.addEventListener(`keydown`, keyHandler);

                this.$once(`hook:destroyed`, () => {
                    document.removeEventListener(`keydown`, keyHandler);
                });
            },
            isImage(image) {
				return image.type ? image.type.substring(0, 5) === 'image' || image.type.substring(0, 14) === 'featured-image' : image.filetype.substring(0, 5) === 'image' ||  image.filetype.substring(0, 14) === 'featured-image';
            }
        },

        directives: {
            clickOutside: vClickOutside.directive
        }
    }
</script>

<style lang="scss">
    .lightbox-thumbnail-wrapper {
        img {
            width: 100%;
        }
    }

    .lightbox {
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, .8);
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;

        .close-lightbox {
            position: absolute;
            color: #fff;
            top: 50px;
            right: 50px;
            font-size: 2em;

            @media(max-width: 767px) {
                top: 22px;
                right: 22px;
            }
        }

        .lightbox-image {
            display: flex;
            width: 100%;
            height: fit-content;
            padding-left: 15px;
            padding-right: 15px;

            img {
                max-height: 90vh !important;
                width: auto !important;
                border-radius: 5px;
                max-width: 90vw !important;
                margin: auto;
            }
        }
    }
</style>
